<template>
  <div class="school-subject-permissions">
    <div style="margin-top: 20px;">
      <!-- <el-button type="primary" size="mini">查询微信列表</el-button> -->
      <el-form size="mini" :inline="true">
        <el-form-item label="学校名称">
          <el-input placeholder="请输入学校名称" v-model="ruleForm.educational_institution_name" clearable @keyup.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="平台账号">
          <el-input placeholder="请输入平台账号" v-model="ruleForm.username" clearable @keyup.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="二级域名">
          <el-input placeholder="请输入二级域名" v-model="ruleForm.domain" clearable @keyup.enter.native="search"></el-input>
        </el-form-item>

        <el-form-item label="客户标签">
          <el-select v-model="ruleForm.tagIds" multiple placeholder="请选择">
            <el-option v-for="item in schoolTagList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目">
          <el-select v-model="ruleForm.subjectIds" multiple filterable>
            <el-option label="全部" value=""></el-option>
            <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目是否包含已到期">
          <el-select v-model="ruleForm.is_contain_timeout_subject">
            <el-option label="全部" value=""></el-option>
            <el-option label="包含" value="1"></el-option>
            <el-option label="不包含" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板是否齐全">
          <el-select v-model="ruleForm.wxQueryState">
            <el-option label="全部" value=""></el-option>
            <el-option label="模板全" value="1"></el-option>
            <el-option label="模板不全" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到期时间">
          <el-date-picker v-model="ruleForm.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" placement="bottom-start"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <!-- <el-button type="primary" size="mini" @click="add">新增</el-button> -->

          <el-button @click="search" type="primary">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-style" style="margin-top: 20px;">
      <el-table size="mini" :data="tableData3" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column width="50" align="center" prop="id" label="序号" fixed="left">
          <template slot-scope="scope">{{
            scope.$index + 1 + 20 * (page_no - 1)
          }}</template>
        </el-table-column>

        <el-table-column width="200" align="left" label="校区名称" fixed="left">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="公众号类型">
          <template slot-scope="scope">
            <span>
              {{scope.row.authorizer_service_type_info == 1?'订阅号':scope.row.authorizer_service_type_info == 2?'服务号':'--'}}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="模板数量">
          <template slot-scope="scope">
            <span @click="addList(scope.row)">
              <span v-if="scope.row.newWxTmpCount != platformTmpTotalNum" style="cursor: pointer;">
                <span style="color: #f00;">{{ scope.row.newWxTmpCount }} /
                  {{ platformTmpTotalNum }}</span>
              </span>
              <span v-else style="cursor: pointer;">
                <span style="color: #00A846;">{{ scope.row.newWxTmpCount }} /
                  {{ platformTmpTotalNum }}</span>
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="150" align="left" label="二级域名">
          <template slot-scope="scope">
            <span>{{ scope.row.domain }}</span>
          </template>
        </el-table-column>

        <el-table-column width="200" align="left" label="地区">
          <template slot-scope="scope">
            <span>{{ scope.row.province }}-</span>
            <span>{{ scope.row.city }}-</span>
            <span>{{ scope.row.area }}</span>
          </template>
        </el-table-column>

        <el-table-column width="200" align="left" label="超管信息">
          <template slot-scope="scope">
            <span v-for="item of scope.row.principalList" :key="item.id">
              <span>{{ item.realname }}</span>
              <span>{{ '(' + item.name + ')' }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="150" align="left" label="客户标签">
          <template slot-scope="scope">
            <el-tag size="mini" v-for="item in scope.row.schoolTagArr" :key="item.id" :color="item.tagInfo.color">
              <span style="color: white">{{ item.tagInfo.name }}</span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column width="80" label="科目权限" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-for="(item, index) in scope.row.schoolSubjectAuthArr" :key="index">
              {{ item.subjectInfo.name }} - {{ item.off_time }}
            </span>
          </template>
        </el-table-column>
        <el-table-column width="" align="left" prop="off_time" label="到期时间"></el-table-column>
        <el-table-column align="center" label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="searchWeChat(scope.row)">查询微信列表</el-button>
            <!-- <el-button type="text" size="mini" @click="add(scope.row)">新增</el-button> -->
            <el-button type="text" size="mini" @click="adminResetSchoolWxAuthorized(scope.row)">解绑公众号</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-sizes="[20, 30, 40, 50, 100]" :current-page.sync="page_no" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="50%">
      <span>模板数 <span v-if="tableData1 == undefined"> 0</span>
        <span v-else>{{ tableData1.length }}</span> / 25</span>
      <el-table size="mini" style="margin-top:10px" :data="tableData1" :header-cell-style="{ background: '#f5f7fa' }" height="50vh">
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="template_id" label="template_id"></el-table-column>
        <el-table-column prop="example" label="模板"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="del1(scope.row)" size="mini" :disabled="scope.row.isShowButton">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible1" width="80%">
      <div style="overflow: hidden;">
        <div style="float: left;width: 49%;">
          <el-table size="mini" :data="tableData2" :header-cell-style="{ background: '#f5f7fa' }">
            <el-table-column prop="title" label="标题"></el-table-column>
            <el-table-column prop="short_id" label="short_id"></el-table-column>
            <el-table-column prop="template_id" label="template_id" width="400"></el-table-column>
            <el-table-column label="操作" fixed="right">
              <template slot-scope="scope">
                <!-- <el-button v-if="scope.row.isShow == 'false'" size="mini" type="text"
                                    disabled>已同步</el-button> -->
                <el-button @click="adminSyncTemplateToSchool(scope.row)" type="text" size="mini" :disabled="scope.row.isShow == 'false' ? true : false">同步</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="float: right;width: 49%;">
          <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
            <el-table-column prop="title" label="标题"></el-table-column>
            <el-table-column prop="short_id" label="short_id"></el-table-column>
            <el-table-column prop="template_id" label="template_id"></el-table-column>
            <!-- <el-table-column prop="content" label="内容"></el-table-column>
                        <el-table-column prop="example" label="模板"></el-table-column>
                        <el-table-column prop="created_time" label="创建时间"></el-table-column> -->
            <el-table-column label="操作" fixed="right">
              <template slot-scope="scope">
                <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    更多
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="del(scope.row)">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAdminWxTemplateList,
  wechatGetTemplateList,
  adminSyncTemplateToSchool,
  adminGetSchoolTemplateList,
  adminGetWechatAuthSchoolList,
  adminGetSchoolTagList,
  getSubjectList,
  adminDeleteTemplateOfPlateform,
  wechatDeleteTemplate,
  adminResetSchoolWxAuthorized
} from '@/api/admin'

export default {
  data() {
    return {
      tableData2: [],
      dialogVisible1: false,
      tableData1: [],
      dialogVisible: false,
      tableData: [],
      //
      ruleForm: {},
      page_no: 1,
      page_size: 20,
      total: 1,
      tableData3: [],
      schoolTagList: [], //标签页面
      subjectList: [],
      platformTmpTotalNum: 0,
      schooId: '',
      wxTemplateArr: [],
    }
  },
  mounted() {
    this.adminGetWechatAuthSchoolList()
    this.getUserSubjectList()
    this.adminGetSchoolTagList()
  },
  methods: {
    // 解绑公众号
    adminResetSchoolWxAuthorized(row) {
      this.$confirm('是否确认解绑公众号？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        adminResetSchoolWxAuthorized({ schoolId: row.id }).then(res => {
          console.log(res)
          if (res.is_update) {
            this.$message.success('操作成功')
            this.adminGetWechatAuthSchoolList()
          } else {
            this.$message.error('操作失败')
          }
        })
      })
    },
    //删除
    del1(row) {
      console.log(row, 123456)
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          wechatDeleteTemplate({
            template_id: row.template_id,
            schoolId: this.schooId,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.adminGetWechatAuthSchoolList()
            this.wechatGetTemplateList(this.schooId)
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    addList(row) {
      this.schooId = row.id
      console.log(row, 123456)
      this.dialogVisible1 = true
      this.adminGetSchoolTemplateList()
      console.log(this.tableData2)
      console.log(this.tableData)
    },
    getUserSubjectList() {
      getSubjectList({
        subject_state: '',
      }).then((res) => {
        this.subjectList = res.subject_list
      })
    },
    //查询校区标签
    adminGetSchoolTagList() {
      adminGetSchoolTagList().then((res) => {
        console.log('查询校区标签')
        console.log(res)
        this.schoolTagList = res.schoolTagList
      })
    },
    search() {
      this.page_no = 1
      this.adminGetWechatAuthSchoolList()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.adminGetWechatAuthSchoolList()
    },
    handleSizeChange(val) {
      this.page_size = val
      this.adminGetWechatAuthSchoolList()
    },
    adminGetWechatAuthSchoolList() {
      adminGetWechatAuthSchoolList({
        wxQueryState: this.ruleForm.wxQueryState,
        domain: this.ruleForm.domain,
        offtime_start_search: this.ruleForm.date ? this.ruleForm.date[0] : '',
        offtime_end_search: this.ruleForm.date ? this.ruleForm.date[1] : '',
        is_contain_timeout_subject: this.ruleForm.is_contain_timeout_subject,
        tagIds: JSON.stringify(this.ruleForm.tagIds),
        subjectIds: JSON.stringify(this.ruleForm.subjectIds),
        educational_institution_name: this.ruleForm
          .educational_institution_name,
        username: this.ruleForm.username,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res, 12346)
        this.tableData3 = res.educational_institution_list
        this.total = res.total
        this.platformTmpTotalNum = res.platformTmpTotalNum
      })
    },
    //删除
    del(row) {
      console.log(row, 123456)
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          adminDeleteTemplateOfPlateform({
            id: row.id,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.adminGetSchoolTemplateList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    //获取校区模板列表
    adminGetSchoolTemplateList() {
      adminGetSchoolTemplateList({
        schoolId: this.schooId,
      }).then((res) => {
        console.log(res)
        this.tableData = res.schoolWxTmpList
        getAdminWxTemplateList().then((res) => {
          console.log(res, 123456)
          this.tableData2 = res.adminWxTmpList
          this.tableData2.map((item) => {
            item.isShow = 'true'
            this.tableData.map((item1) => {
              if (item.template_id == item1.template_id) {
                item.isShow = 'false'
              }
            })
          })
          console.log(this.tableData)
          console.log(this.tableData2)
        })
      })
    },
    //同步
    adminSyncTemplateToSchool(row) {
      adminSyncTemplateToSchool({
        platformTemplateId: row.id,
        schoolId: this.schooId,
      }).then((res) => {
        console.log(res, 12465)
        this.$message.success('同步成功')
        this.adminGetSchoolTemplateList()
        this.adminGetWechatAuthSchoolList()
      })
    },
    searchWeChat(row) {
      this.schooId = row.id

      this.dialogVisible = true
      adminGetSchoolTemplateList({
        schoolId: this.schooId,
      }).then((res) => {
        console.log(res)
        // res.schoolWxTmpList
        this.wxTemplateArr = res.schoolWxTmpList
      })
      this.wechatGetTemplateList(row.id)
    },
    wechatGetTemplateList(id) {
      wechatGetTemplateList({
        schoolId: id,
      }).then((res) => {
        console.log(res, 123456)
        this.tableData1 = res.weReturnData.template_list
        console.log(this.tableData1, 123456)
        this.tableData1.map((item) => {
          item.isShowButton = false
          this.wxTemplateArr.map((item1) => {
            if (item.template_id == item1.template_id) {
              item.isShowButton = true
            }
          })
        })

        console.log(this.tableData1, 11234)
      })
    },
    getAdminWxTemplateList() {
      getAdminWxTemplateList().then((res) => {
        console.log(res, 123456)
        this.tableData2 = res.adminWxTmpList
      })
    },
  },
}
</script>

<style scoped lang="scss">
.school-subject-permissions {
  height: 100%;
  background-color: #fff;
  padding-top: 3px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  margin: 10px;
  border-radius: 5px;

  .table-style {
  }
}
</style>
